// src/pages/PrivacyPolicy.js
import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.crokchef.com/api';

const PrivacyPolicy = () => {
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const [lastUpdate, setLastUpdate] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/info?slug=politica-privacidad`);
        if (!response.ok) throw new Error('Error al cargar la política');
        const data = await response.json();

        // La API devuelve un array con un solo objeto
        if (Array.isArray(data) && data.length > 0) {
          const record = data[0];
          setContent(record.content || '');
          setTitle(record.name || 'Política de Privacidad');
          setLastUpdate(record.updated_at || record.created_at || '');
        } else {
          throw new Error('No se encontró la política de privacidad');
        }
        setError(null);
      } catch (err) {
        console.error(err);
        setError('No pudimos cargar la política de privacidad. Intenta más tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  // ... (loading y error igual que antes)

  return (
    <div className="max-w-4xl mx-auto px-4 py-20">
      <div className="page-header text-center">
        <h1 className="page-title">
          {title}
        </h1>
      </div>
        
      
      {lastUpdate && (
        <p className="text-sm text-gray-500 mb-8">
          Última actualización: {new Date(lastUpdate).toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </p>
      )}
      <div
        className="text-sm text-gray-500 mb-8"
        style={{ color: 'var(--text-color)' }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default PrivacyPolicy;